export enum DocumentTypeCode {
  AROI = 'AROI',
  BOLD = 'BOLD',
  CINV = 'CINV',
  CMCN = 'CMCN',
  CNFA = 'CNFA',
  CREN = 'CREN',
  DEBN = 'DEBN',
  DISP = 'DISP',
  DNFA = 'DNFA',
  HIRI = 'HIRI',
  MSIN = 'MSIN',
  PUOR = 'PUOR',
  SBIN = 'SBIN',
  SOAC = 'SOAC',
  TSUT = 'TSUT',
  VCHR = 'VCHR',
}
